if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',

    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Only initialize on mobile
        if (window.innerWidth <= 767) {
          document.body.classList.add('mobile-sticky-bar-enabled');
          this.calculateHeight();
        }
      }

      disconnectedCallback() {
        // No scroll to remove
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }
    }
  );
}
